import {PopoutCard} from '../..'

export const TruncateTooltip = ({text, element, width}) => (
	<PopoutCard
		className="eitje-text-wrapper"
		layoutProps={{maxWidth: '100%'}}
		wrapperLayoutProps={{maxWidth: '100%', width, grow: true}}
		title={text}
	>
		{element}
	</PopoutCard>
)
